import { Flex } from "@chakra-ui/react";
import { Input } from "@chakra-ui/react";
import { formatMoney } from "infra/helpers/number";

export default function RowTable({
  item,
  saldoParcial,
}: {
  item: any;
  saldoParcial?: boolean;
}) {
  return (
    <Flex
      py={2}
      px={6}
      gap={4}
      align="center"
      borderX="solid 1px #EBEBEB"
      borderBottom="solid 1px #EBEBEB"
    >
      <Flex flex={1}>
        <Input value={item.debito} />
      </Flex>
      <Flex flex={1}>
        <Input value={item.credito} />
      </Flex>
      <Flex flex={1.6} mr={10}>
        <Input value={item.historico} />
      </Flex>
      <Flex mr={2} flex={0.4} justifyContent="flex-end">
        {formatMoney(item.valor)}
      </Flex>
      {saldoParcial ? (
        <Flex mr={2} flex={0.4} justifyContent="flex-end">
          {formatMoney(item?.saldoParcial)}
        </Flex>
      ) : null}
    </Flex>
  );
}
